import React, {Component} from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { formatDateTime } from "../../api";
import {Link} from 'react-router-dom';

class DBEvents extends Component {
    render(){
            const { item } = this.props;
            const LandingPages = [];

            item.orders.forEach(order => {
                const date = order.createdAt;
                order.items.forEach(orderItem => {
                    const title = orderItem.title;
                    if (orderItem.landingPage) {
                        LandingPages.push ({ date: date, title: title, link: orderItem.landingPage})
                    }
                })
            })

            return (                                
                <div className="dashboard-right">
                    <div className="dashboard">
                        <div className="page-title">
                            <h2>My Dashboard</h2>
                        </div>
                        <div className="welcome-msg">
                            <p>These are the pages associated with the products you have purchased and events for which you have registered. </p><br/>
                        </div>
                        <div className="box-account box-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ReactTable
                                        data={LandingPages}
                                        columns={[{
                                            Header: 'Product',
                                            accessor: 'title',
                                          },{
                                            Header: 'Date',
                                            accessor: 'date', // String-based value accessors!
                                            Cell: props => <span>{formatDateTime(new Date(props.value))}</span>
                                          },{
                                            Header: 'Page Link',
                                            accessor: 'link', // String-based value accessors!
                                            Cell: props => <Link to={props.value}>Goto Page</Link>
                                          }]}                                        
                                        defaultPageSize={10}
                                        showPagination={true}                                        
                                    />
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
        )
    }
}

export default DBEvents

